import React from "react";
import { Info } from "lucide-react";

/**
 * Renders a small preview of the final tracking URL that will be sent to
 * Meta — with `tmcid`, `tmsid`, `utm_campaign`, `utm_term` placeholders
 * resolved for an example campaign/adset pair. The actual values get
 * stamped per (campaign, adset) at launch time.
 */
export default function UrlPreview({ baseUrl, addTm, addUtm, sampleCampaign = "{campaign_name}", sampleAdset = "{adset_name}", sampleCampaignId = "{campaign_id}", sampleAdsetId = "{adset_id}" }) {
  if (!baseUrl) return null;
  const parts = [];
  if (addTm) {
    parts.push(`tmcid=${sampleCampaignId}`);
    parts.push(`tmsid=${sampleAdsetId}`);
  }
  if (addUtm) {
    parts.push(`utm_campaign=${encodeURIComponent(sampleCampaign)}`);
    parts.push(`utm_term=${encodeURIComponent(sampleAdset)}`);
  }
  let final = baseUrl.trim();
  if (parts.length) {
    const joiner = final.includes("?") ? "&" : "?";
    final = `${final}${joiner}${parts.join("&")}`;
  }
  return (
    <div data-testid="url-preview" className="mt-2 p-2 bg-zinc-50 border border-zinc-200 text-[11px] font-mono">
      <div className="flex items-center gap-1 text-zinc-500 uppercase tracking-wider text-[9px] mb-1">
        <Info className="w-3 h-3" />
        Final URL preview (placeholders are filled per ad-set at launch)
      </div>
      <div className="break-all text-zinc-800 leading-snug">{final}</div>
    </div>
  );
}
